module.exports = __webpack_public_path__ + "media/images/seed_file-15f2e655715e48125686b7846abff552.png";